import { render, staticRenderFns } from "./AbsenceReasonPage.vue?vue&type=template&id=6aad63fc&"
import script from "./AbsenceReasonPage.vue?vue&type=script&lang=js&"
export * from "./AbsenceReasonPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports